<template>
<div class="ti">
  <div>
    <el-button size="mini" type="primary text2" @click="modals" v-if="ERP.isPermission(7001001)">添加组织</el-button>

    <el-input size="mini" class="search" placeholder="请输入组织名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">组织名称</th>
            <th class="text-left">组织电话</th>
            <th class="text-left">限制项目数</th>
            <th class="text-left">创建人</th>
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.company_name}}</td>
            <td >{{item.company_phone}}</td>
            <td >{{item.company_number}}</td>
            <td >{{item.adname}}</td>
            <td >{{item.dade}}</td>
            <td class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="xiugai( item.id )" v-if="ERP.isPermission(7001002)">修改</div>
              <div  style="color: red;margin-left: 5px;cursor: pointer;" @click="del( item.id )" v-if="ERP.isPermission(7001003)">删除</div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        title="编辑"
        @on-ok="ok">
        <div>
          <el-form  label-width="80px" :model="dades">
            <el-form-item label="组织名称">
              <el-input v-model="dades.company_name"></el-input>
            </el-form-item>
            <el-form-item label="组织电话">
              <el-input v-model="dades.company_phone"></el-input>
            </el-form-item>
            <el-form-item label="限制项目">
              <el-input v-model="dades.company_number"></el-input>
              <span class="con">限制该组织最多新建多少项目,填写数量</span>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
</div>

</template>

<script>
export default {
  name: "JAdd",
  data () {
    return {
      dades: {
        id:'',
        login_name:'',
        company_name: '',
        company_phone: '',
        company_number:'',
      },
      anxiu:'保存',
      modal1: false,
      input1: '',
      desserts: '',
      total:0,
      page:12,
      search:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    ERP.showLoading()
    this.$Loading.start();
    var t = Date.parse(new Date()) / 1000;//时间戳
    this.$myhttp.get('admin/Jindexadd?id=1'+'&t='+t,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.desserts = backdata.data[0];
        this.total = backdata.data[1];
        this.$Loading.finish();
      ERP.hideLoading()
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //弹窗添加
    modals(){
      this.$Loading.start();
      this.anxiu = "保存";
      this.dades = {id:'',company_name: '',company_phone: '',};
      this.modal1 = true;
      this.$Loading.finish();
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/Jindexadd?id='+ e + '&search='+ this.search+'&t='+t,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/Jindexadd?search='+ this.search + '&id=1'+'&t='+t,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
      });
    },
    //删除
    del(e){
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$confirm('此操作将永久删除该公司，删除将导致不可修复，删除先联系维护人员确定, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$Loading.start();
          this.$myhttp.post('admin/Jindexdel',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data['code'] == 60006){
                 this.$Loading.finish();
                 this.$Message.error(backdata.data['date']);
                 return false;
              }
              if(backdata.data == 1){
                this.dela = true;
                this.$myhttp.get('admin/Jindexadd?id=1'+'&t='+t,{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.$Loading.finish();
                    this.$Message.success('删除成功!');
                  });
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //添加保存
    ok () {
      if(this.dades.company_name == ""){
        this.$Message.error('组织名称不能为空!');
        return false;
      }
      if(this.dades.company_phone == ""){
        this.$Message.error('组织电话不能为空!');
        return false;
      }
      if(this.dades.company_number == ""){
        this.$Message.error('组织项目数不能为空!');
        return false;
      }
      var login = window.localStorage.getItem('login');
      this.dades.login_name = login;
      this.$Loading.start();
      this.$myhttp.post('admin/Jindexadds',this.dades,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0] == 1){
            var t = Date.parse(new Date()) / 1000;//时间戳
            this.$myhttp.get('admin/Jindexadd?id=1'+'&t='+t,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
            });
            this.$Loading.finish();
            this.$Message.success(backdata.data[1]);
          }else{
            this.$Loading.finish();
            this.$Message.error('编辑失败!');
          }
      });
    },
    //修改查询
    xiugai(e){
      this.$Loading.start();
      this.anxiu="修改";
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/Jindexupdete?id='+e+'&t='+t,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.dades = backdata.data[0];
          this.$Loading.finish();
          this.modal1 = true;
      });
    }

  }
}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.con{
  color: rgb(57, 136, 74);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Jurisdiction/JAdd.vue